import { render, staticRenderFns } from "./ShareBottom.vue?vue&type=template&id=3dc50e62&scoped=true&"
import script from "./ShareBottom.vue?vue&type=script&lang=js&"
export * from "./ShareBottom.vue?vue&type=script&lang=js&"
import style0 from "./ShareBottom.vue?vue&type=style&index=0&id=3dc50e62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../share_webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc50e62",
  null
  
)

export default component.exports